import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-glm-materias-card',
  standalone: false,
  templateUrl: './glm-materias-card.component.html',
  styleUrls: ['./glm-materias-card.component.scss']
})
export class GlmMateriasCardComponent implements OnInit {

  @Input()
  materias: Array<any>;

  @Input()
  propio: boolean;

  @Input()
  hijo: any;

  @Output()
  detalleOpen = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  emitDetalle(event) {
    this.detalleOpen.emit(event);
  }

}
